import type { ListMealsQuery } from '@/types/api';

export const mealKeys = {
  all: ['meals'] as const,
  lists: () => [...mealKeys.all, 'list'] as const,
  list: (params?: ListMealsQuery) =>
    [
      ...mealKeys.lists(),
      params?.query ?? '',
      params?.tags?.join(',') ?? '',
      params?.page ?? 1,
      params?.limit ?? 20,
    ] as const,
  details: () => [...mealKeys.all, 'detail'] as const,
  detail: (id: number) => [...mealKeys.details(), id] as const,
  tags: () => [...mealKeys.all, 'tags'] as const,
};
